<template>
  <el-table
    border
    size="mini"
    :data="data"
    v-loading="loading"
    :row-class-name="tableRowClassName"
    class="avaliable-files"
  >
    <el-table-column :label="$t('text.alias')" prop="Alias"> </el-table-column>
    <el-table-column :label="$t('text.status')" prop="Status">
    </el-table-column>
    <el-table-column :label="$t('text.created_date')" prop="CreatedDateTime">
    </el-table-column>
    <el-table-column :label="$t('text.action')">
      <template slot-scope="scope">
        <div
          class="blue-font underline pointer inline-block"
          @click="downloadReport(scope.row)"
          v-if="scope.row.Status === 'COMPLETED'"
        >
          <span>{{ $t('text.download') | firstLetterCapitalize }}</span>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import moment from 'moment-timezone'
import { storageUrl } from '@/const'
export default {
  data() {
    return {
      loading: false,
      data: [],
      timer: null
    }
  },
  mounted() {
    this.getData()
    this.timer = setInterval(() => this.getData(false), 10000)
  },
  methods: {
    getData(showLoading = true) {
      if (showLoading) this.loading = true
      ApiService.GetPatientReportHistory(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.data = response.data.data.map(item => {
              return {
                ...item,
                FromDate: moment(item.FromDate).format('YYYY-MM-DD HH:mm:ss'),
                ToDate: moment(item.ToDate).format('YYYY-MM-DD HH:mm:ss'),
                CreatedDateTime: moment
                  .utc(item.CreatedDateTime)
                  .tz(moment.tz.guess(true))
                  .format('YYYY-MM-DD HH:mm:ss')
              }
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    tableRowClassName({ row }) {
      // status: pending, initiated, failed, complete
      if (row.Status === 'FAILED') {
        return 'failed-row'
      }
      return ''
    },
    downloadReport(item) {
      if (item.Status !== 'COMPLETED') return
      window.open(`${storageUrl}/uploads/${item.ReportId}.csv`, '_blank')
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.avaliable-files::v-deep {
  &.el-table .failed-row {
    background-color: rgba(240, 179, 188, 1) !important;
  }
}
</style>
